// extracted by mini-css-extract-plugin
export var buttonIconWrapper = "_7z-4";
export var collapsed = "_7z-1";
export var headerBar = "_7z-0";
export var leftHeaderContent = "_7z-3";
export var subjectContainer = "_7z-2";